import { render, staticRenderFns } from "./tm-info-page.vue?vue&type=template&id=a61264e4&"
import script from "./tm-info-page.vue?vue&type=script&lang=ts&"
export * from "./tm-info-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-info-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports